/**
 * Home "Features of our products" section: a tall sticky stage where the two
 * columns counter-scroll vertically (IX2 a-21) as the section passes through.
 */
import type { FC } from 'react'

import { useEffect, useRef } from 'react'

import { gsap } from '@/lib/gsap'

export const Features: FC = () => {
    const holderRef = useRef<HTMLDivElement>(null)
    const stickyRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const holder = holderRef.current
        const sticky = stickyRef.current
        if (!holder || !sticky) return

        const ctx = gsap.context(() => {
            // The box pins itself with CSS `position: sticky; top: 0` (see
            // animations.css). It sits at the top of the top-aligned 230vh
            // holder, so it catches the moment the holder's top reaches the
            // viewport top and stays stuck through the 135vh beneath it. Scrub
            // the counter-scroll across exactly that window (holder top→top
            // until holder bottom→bottom), so the columns start moving once the
            // box is stuck and reach 100% as the section scrolls away.
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: holder,
                    start: 'top top',
                    end: 'bottom bottom',
                    scrub: true
                }
            })

            tl.fromTo('.features-left-section-container', { yPercent: 0 }, { yPercent: -100, ease: 'none' }, 0)
                .fromTo('.features-right-section-container', { yPercent: -100 }, { yPercent: 0, ease: 'none' }, 0)
        }, holder)

        return () => ctx.revert()
    }, [])

    return (
        <div className='section'>
            <div className='container'>
                <div className='fade-in-move-on-scroll'>
                    <h2>Features of our products</h2>
                </div>
                <div className='fade-in-move-on-scroll'>
                    <div ref={holderRef} className='features-section-holder'>
                        <div ref={stickyRef} className='features-section-sticky'>
                            <div className='features-card-holder'>
                                <div className='features-card-container'>
                                    <div className='features-left-section'>
                                        <div className='features-left-section-container'>
                                            <h3 className='white-text home-page'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h3>
                                            <p className='grey-text home-page'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed auctor netus mauris velit vulputate lectus aliquam. Faucibus posuere at euismod turpis feugiat porta vestibulum.</p>
                                        </div>
                                        <div className='features-left-section-container white'>
                                            <h3 className='slider-title'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h3>
                                            <p className='light-text home-page'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed auctor netus mauris velit vulputate lectus aliquam. Faucibus posuere at euismod turpis feugiat porta vestibulum.</p>
                                        </div>
                                    </div>
                                    <div className='features-right-section'>
                                        <div className='features-right-section-container'>
                                            <img
                                                src='/images/Hero-Image.jpg'
                                                loading='lazy'
                                                alt=''
                                                sizes='(max-width: 479px) 94vw, (max-width: 767px) 46vw, (max-width: 1439px) 47vw, 647px'
                                                srcSet='/images/Hero-Image-p-500.jpg 500w, /images/Hero-Image-p-800.jpg 800w, /images/Hero-Image-p-1080.jpg 1080w, /images/Hero-Image.jpg 1668w'
                                                className='feature-image'
                                            />
                                        </div>
                                        <div className='features-right-section-container'>
                                            <img
                                                src='/images/Footer-Image.jpg'
                                                loading='lazy'
                                                alt=''
                                                sizes='(max-width: 479px) 94vw, (max-width: 767px) 46vw, (max-width: 1439px) 47vw, 647px'
                                                srcSet='/images/Footer-Image-p-500.jpg 500w, /images/Footer-Image-p-800.jpg 800w, /images/Footer-Image.jpg 1200w'
                                                className='feature-image'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
